import visitsDomain from './visits';
import payerDomain from './payer';
import partnersDomain from './partners';
import authDomain from './auth';

const oneSecond = 1000;

const evvToken = 'evvToken';

const upDirection = 'up';

const downDirection = 'down';

const logoutMessage = 'You have logged out successfully!';

export {
  visitsDomain,
  partnersDomain,
  payerDomain,
  authDomain,
  oneSecond,
  evvToken,
  upDirection,
  downDirection,
  logoutMessage,
};
